import { useState, useEffect } from 'react';
import config from '../config';

/**
 * Custom hook to fetch public organizations without authentication
 * @returns {Object} Object containing organizations data, loading state, and error state
 */
export const usePublicOrganizations = () => {
  const [organizations, setOrganizations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        setIsLoading(true);
        setError(null);
        
        // Fetch organizations from public API
        const response = await fetch(`${config.API_URL}/api/public-organizations`);

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.detail || 'Failed to fetch organizations');
        }

        const data = await response.json();
        console.log('Fetched public organizations:', data.organizations);
        setOrganizations(data.organizations || []);
      } catch (err) {
        console.error('Error fetching public organizations:', err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchOrganizations();
  }, []);

  return { organizations, isLoading, error };
};
